import { action, flow, makeObservable, observable } from 'mobx';
import { betHistoryService } from '../services/betHistoryService';
import { HttpResponse } from '../core/classes/HttpResponse';
import { RequestStatus } from '../core/constants/requestStatus';

class BetHistoryStore {
  betHistory = new HttpResponse([]);

  betHistoryTotalCount = null;

  betsDefaultTake = 20;

  resetBeforeGet = false;

  gameCurrentRoundId = null;

  constructor() {
    makeObservable(this, {
      betHistoryTotalCount: observable,
      gameCurrentRoundId: observable,
      betHistory: observable.deep,
      setBetHistoryTotalCount: action.bound,
      setBetHistory: action.bound,
      updateLastBet: action.bound,
      setGameCurrentRoundId: action.bound,
      resetBetHistory: action.bound,
      getBetHistory: flow,
      getLastBet: flow,
    });
  }

  setBetHistory(betHistory) {
    this.betHistory = betHistory;
  }

  setBetHistoryTotalCount(count) {
    this.betHistoryTotalCount = count;
  }

  fetchedBetHistory(response) {
    this.setBetHistory(this.betHistory.fetched([...this.betHistory.data, ...response]));
  }

  resetBetHistory() {
    if (this.betHistory.status === RequestStatus.Pending) {
      this.resetBeforeGet = true;
    }
    this.betHistory = new HttpResponse([]);
    this.setBetHistoryTotalCount(null);
  }

  updateLastBet(response) {
    if (!this.betHistory.data.find((el) => JSON.stringify(el) === JSON.stringify(response[0]))) {
      this.setBetHistory(this.betHistory.fetched([...response, ...this.betHistory.data]));
    }
  }

  fetchingBetHistory() {
    this.setBetHistory(this.betHistory.fetching());
  }

  setGameCurrentRoundId(roundId) {
    this.gameCurrentRoundId = roundId;
  }

  *getLastBet(take = 1) {
    const {
      data: {
        result: { count, items },
      },
    } = yield betHistoryService.getBetHistory(
      this.gameCurrentRoundId
        ? { roundId: this.gameCurrentRoundId }
        : {
            skip: 0,
            take,
          }
    );

    this.updateLastBet(items);
    this.setBetHistoryTotalCount(count);
  }

  *getBetHistory() {
    if (this.betHistory.status === RequestStatus.Pending) {
      return;
    }

    if (this.resetBeforeGet) {
      this.resetBetHistory();
      this.resetBeforeGet = false;
    }

    if (
      !this.betHistoryTotalCount ||
      !this.betHistory.data.length ||
      this.betHistory.data.length + 1 < this.betHistoryTotalCount
    ) {
      this.fetchingBetHistory();
      const {
        data: {
          result: { count, items },
        },
      } = yield betHistoryService.getBetHistory({
        skip: this.betHistory.data.length,
        take: this.betsDefaultTake,
      });
      this.fetchedBetHistory(items);
      this.setBetHistoryTotalCount(count);
    }
  }
}

export const betHistoryStore = new BetHistoryStore();
